import * as React from 'react';

import { EntityActions, EntityType } from 'common/entity';

import { AppState } from 'common/models/AppState';
import { Chapter } from 'common/api/models/Chapter';
import { ChapterApi } from 'common/api/resources/ChapterApi';
import { Datetime } from 'common/components/Datetime';
import { Loading } from 'common/components/Loading';
import { RowActionButton } from 'common/components/RowActionButton';
import { MemberLink } from 'common/components/link/MemberLink';
import { toApiError, getExportUrl, getChaptersWordPressUrl } from 'common/utils/api';

interface ChaptersTableProps {
  appState: AppState;
  entityActions: EntityActions;
  reloadAt: Date;
  onEdit: (chapter: Chapter) => void;
  onClick: (id: string) => void;
}

interface ChaptersTableState {
  chapters: Chapter[];
  isLoading: boolean;
  error?: string;
}

function keysrt(key: string): any {
  return function sorter(a: any, b: any) {
    if (a[key] < b[key]) {
      return -1;
    } else if (a[key] > b[key]) {
      return 1;
    }
    return 0;
  };
}

export class ChaptersTable extends React.Component<ChaptersTableProps, ChaptersTableState> {
  state: ChaptersTableState = { chapters: [], isLoading: true };

  handleRowClick = (e: React.MouseEvent<HTMLTableRowElement>) => {
    e.stopPropagation();
    this.props.onClick(e.currentTarget.dataset.id!);
  };

  componentDidMount() {
    this.reload();
  }

  componentDidUpdate(prevProps: ChaptersTableProps) {
    if (prevProps.reloadAt !== this.props.reloadAt) {
      this.reload();
    }
  }

  reload() {
    this.setState({ isLoading: true });

    ChapterApi.findChapters().then(
      res => {
        this.setState({ chapters: res.data.sort(keysrt('name')), isLoading: false });
        res.data.map(d => {
          this.props.entityActions.fetchIfPresent(EntityType.MEMBER, d.updateId);
        });
      },
      err => {
        this.setState({ error: toApiError(err), isLoading: false });
      }
    );
  }

  handleSort = (key: keyof Chapter) => {
    this.setState(s => ({ ...s, chapters: s.chapters.sort(keysrt(key)) }));
  };

  render() {
    const cols = 6;
    return (
      <div>
        {this.state.error && (
          <div className="alert alert-danger" style={{ marginTop: 20 }}>
            {this.state.error}
          </div>
        )}

        <table className="table-clickable table table-striped table-hover" style={{ width: '100%' }}>
          <thead>
            <tr>
              <th onClick={() => this.handleSort('name')}>Name</th>
              <th onClick={() => this.handleSort('region')}>Region</th>
              <th>Status</th>
              <th>Updated</th>
              <th>Updated By</th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>
            {this.state.isLoading && (
              <tr>
                <td colSpan={cols}>
                  <Loading />
                </td>
              </tr>
            )}
            {this.state.chapters.length === 0 && (
              <tr>
                <td colSpan={cols}>No results found.</td>
              </tr>
            )}
            {this.state.chapters.map(c => (
              <tr key={c.id} data-id={c.id} onClick={this.handleRowClick}>
                <td>{c.name}</td>
                <td>{c.region}</td>
                <td>
                  {c.publish === undefined ? '' : c.publish ? 'Published' : c.buildWordPressTemplate ? 'Pending' : ''}
                </td>
                <td>
                  <Datetime at={c.updateAt} />
                </td>
                <td>
                  <MemberLink member={this.props.appState.entities.member[c.updateId!]} />
                </td>
                <td>
                  <a
                    className="btn btn-primary btn-sm mr-2"
                    href={getExportUrl(`/v2/member/chapter/${c.id}/export`)}
                    onClick={e => {
                      e.stopPropagation();
                    }}
                  >
                    <i className="fa fa-download" />
                  </a>
                  <RowActionButton item={c} icon="pencil" onClick={this.props.onEdit} />

                  {c.wordpressUrl && c.wordpressUrl.length > 0 ? (
                    <a
                      className="btn btn-secondary btn-sm mr-2"
                      style={{ marginLeft: 8 }}
                      href={getChaptersWordPressUrl(c.wordpressUrl)}
                      target="_blank"
                      onClick={e => {
                        e.stopPropagation();
                      }}
                    >
                      <i className="fa fa-eye" />
                    </a>
                  ) : null}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/screens/Chapters/ChaptersTable.tsx